import { Icon } from '../icon';
import { Input } from '../input';

import type { InputProps } from '../input';

export const Search = (props: SearchProps) => {
  const { appearance = 'filled', ...rest } = props;

  return <Input gap="medium" placeholder="Search" appearance={appearance} left={<Icon type="search-01" size={20} />} {...rest} />;
};

interface SearchProps extends InputProps {}
